import { convertToLocalTime } from 'utils';
import { InfoBlock } from '../InfoBlock';
import { BidHistorySection } from 'pages/Shared/VehicleDetails/components';
import { BidHistoryProps } from './types';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { VEHICLE_STATUSES } from 'constants';

export const AABids = ({ vehicle, initiallyCollapsed }: BidHistoryProps) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);

  const bids = vehicle.bids.map((bid: any) => ({
    id: bid.id,
    bid: bid.amount,
    bidder: bid.bidder?.dealership_name,
    date: convertToLocalTime(bid.created_at, true),
    created_at: bid.created_at
  }));

  const isAwarded = vehicle.status === VEHICLE_STATUSES.AWARDED;
  const offerAuctionStarted = (offerAuction?.offerBids?.length ?? 0) > 0;
  const awardInfo =
    isAwarded && !offerAuctionStarted && vehicle.awarded_user
      ? { amount: vehicle.vehicle_price, buyerName: vehicle.awarded_user.dealership_name }
      : undefined;

  return (
    <InfoBlock>
      <BidHistorySection
        auctionType={'autoaxess'}
        type={'bids'}
        initiallyCollapsed={initiallyCollapsed}
        bids={bids}
        proxyBid={vehicle.proxy_bid}
        awardInfo={awardInfo}
      />
    </InfoBlock>
  );
};
